export default __webpack_public_path__ + "static/media/account_03.583d207b.png";